import * as React from 'react';
import { forwardRef } from 'react';

export const LBTelegramIcon = forwardRef<
  SVGSVGElement,
  React.ComponentPropsWithoutRef<'svg'>
>((props, ref) => (
  <svg
    {...props}
    ref={ref}
    fill='none'
    height={24}
    width={24}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.5 0a11.499 11.499 0 0 0-8.13 19.632A11.499 11.499 0 1 0 12.5 0Z'
      fill='currentColor'
    />
    <path
      d='M5.432 11.873a583.81 583.81 0 0 1 6.997-3.014c3.334-1.386 4.026-1.627 4.478-1.635.1-.002.32.023.465.14.12.098.154.231.17.325.015.093.036.306.02.472-.18 1.897-.963 6.502-1.36 8.627-.167.9-.499 1.201-.82 1.23-.697.065-1.226-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.248-2.977 3.306-3.23.008-.032.015-.15-.056-.212-.07-.063-.173-.041-.248-.024-.107.024-1.792 1.139-5.062 3.345-.478.33-.911.49-1.301.481-.428-.01-1.253-.242-1.866-.441-.75-.245-1.348-.374-1.296-.789.027-.216.325-.437.893-.663Z'
      fill='#fff'
    />
    <defs>
      <linearGradient
        gradientUnits='userSpaceOnUse'
        id='a'
        x1={1151}
        x2={1151}
        y1={0}
        y2={2300}
      >
        <stop stopColor='#2AABEE' />
        <stop offset={1} stopColor='#229ED9' />
      </linearGradient>
    </defs>
  </svg>
));
